import tw from "twin.macro";

export const toggleCss = tw`relative flex items-center text-light bg-riverBed bg-opacity-25 border border-white border-solid self-baseline p-0.5 rounded-full w-[48px] min-w-[48px] cursor-pointer select-none transition-colors`;

export const toggleCheckedCss = tw`bg-dodgerBlue`;

export const toggleDisabledCss = tw`bg-riverBed bg-opacity-50 pointer-events-none`;
